import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
`;

export const Modal = styled.div`
  height: 80vh;
  width: 80vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  position: relative;
`;

export const SmallImage = styled.img`
  width: auto;
  max-width: 350px;
  max-height: 300px;
  transition: transform 0.3s ease;
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 80vh;
  transition: transform 0.3s ease;
`;

